import { makeStyles } from '@material-ui/styles';
import css from 'styled-jsx/css';
import { colors } from 'components/styles/variables';
import closeButton from 'public/static/images/srp/Close_Mobile.svg';

export const useStyles = makeStyles({
  inputField: {
    marginBottom: '15px',
  },

  downPaymentField: {
    width: '100%',
  },

  toggleButtonGroup: {
    height: '25px',
    paddingLeft: '10px',
  },

  toggleButton: {
    width: '45px',
    fontSize: '14px',
  },

  selectOption: {
    fontSize: '15px',
  },

  inputLabel: {
    fontSize: '16px',
    fontWeight: 'bold',
  },

  input: {
    fontSize: '20px',
  },

  closeButton: {
    position: 'absolute',
    top: '5px',
    right: '5px',
    backgroundPosition: 'center',
    backgroundImage: `url(${closeButton})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '16px 16px',
    padding: 0,
    width: '40px',
    height: '40px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
});

export default css`
  .monthly-payment-calculator-container {
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    color: ${colors.BLACK};
    overflow: hidden;
  }

  .header {
    font-size: 25px;
    font-weight: 600;
    line-height: 26px;
    margin-bottom: 20px;
  }

  .description {
    font-size: 18px;
    margin-bottom: 30px;
  }

  .terms {
    font-size: 18px;
    margin-bottom: 30px;
  }

  .down-payment-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 15px;
  }
`;
